<template>
   <iframe
    src="/uau1/index.html"
    style="width:100%; height:100vh; border:none;"
  />
</template>

<script>
export default {
  name: "UAUView"
}
</script>